"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDayAvailable = exports.isAvailable = exports.getTime = exports.default = exports.daysOfTheWeekBitwise = void 0;

var _Timezone = _interopRequireDefault(require("../../Tools/Timezone"));

var _Period = _interopRequireDefault(require("./Period"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const daysOfTheWeekBitwise = {
  0: 1,
  1: 2,
  2: 4,
  3: 8,
  4: 16,
  5: 32,
  6: 64
};
exports.daysOfTheWeekBitwise = daysOfTheWeekBitwise;

const isAvailable = (item, date = null, timezoneOffset = 0) => {
  try {
    if (!item) return true;
    let now = date || getTime(timezoneOffset);
    let weekDay = now.getDay();
    let hourTime = +`${`${now.getHours()}`.padStart(2, '0')}${`${now.getMinutes()}`.padStart(2, '0')}`;
    /* se não estiver definido não aplica indisponibilidade */

    if (!item.availability) return true;
    const {
      daysOfTheWeek,
      periods
    } = item.availability;
    /* Verifica se dia da semana está de acordo */

    if (!isDayAvailable(daysOfTheWeek, weekDay)) return false;
    /* Verifica se horários estão de acordo */

    return periods.filter(period => +period.beginTime.replace(':', '') <= hourTime && +period.endTime.replace(':', '') >= hourTime).length > 0;
  } catch (err) {
    console.log(`Error : isAvailable :: ${err}`);
  }
};

exports.isAvailable = isAvailable;

const isDayAvailable = (daysOfTheWeek, weekDay) => {
  return (daysOfTheWeek & daysOfTheWeekBitwise[weekDay]) == daysOfTheWeekBitwise[weekDay];
};

exports.isDayAvailable = isDayAvailable;

const getTime = timezoneOffset => {
  process.env.TZ = "UTC";
  const date = new Date();

  const now = _Timezone.default.adjustTime(date, date.getTimezoneOffset() / 60, timezoneOffset);

  return now;
};

exports.getTime = getTime;

class Availability {
  constructor() {
    _defineProperty(this, "daysOfTheWeek", null);

    _defineProperty(this, "periods", []);
  }

  static fromObject(obj) {
    let availability = new Availability();
    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'daysOfTheWeek':
          availability[key] = value;
          break;

        case 'periods':
          availability[key] = value.map(period => _Period.default.fromObject(period));
          break;
      }
    });
    return availability;
  }

}

exports.default = Availability;